var React = require('react');

function Adviser (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7 1.5C8.7 1.5 10 2.8 10 4.5C10 6.2 8.7 7.5 7 7.5C5.3 7.5 4 6.2 4 4.5C4 2.8 5.3 1.5 7 1.5ZM7 0C4.5 0 2.5 2 2.5 4.5C2.5 7 4.5 9 7 9C9.5 9 11.5 7 11.5 4.5C11.5 2 9.5 0 7 0Z","fill":"#4187F5","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.5 12.75C2.61851 12.75 1.75 13.6016 1.75 14.9V18H0.25V14.9C0.25 12.9984 1.58149 11.25 3.5 11.25H10.5C12.4185 11.25 13.75 12.9984 13.75 14.9V18H12.25V14.9C12.25 13.6016 11.3815 12.75 10.5 12.75H3.5Z","fill":"#4187F5","key":1})]);
}

Adviser.defaultProps = {"width":"14","height":"18","viewBox":"0 0 14 18","fill":"none"};

module.exports = Adviser;

Adviser.default = Adviser;
